import { Box, Stack, Typography } from '@mui/material'
import { useContext, useEffect } from 'react'
import {
  AddressContext,
  AddressProviderValue,
} from 'pages/address/address.provider'
import { useCustomerList } from 'pages/address/address.hooks'
import AddressCustomerListItem from './address-customer-list-item.component'

const AddressCustomerList = () => {
  const { selectedAssociationId, setSelectedAssociationId } = useContext(
    AddressContext
  ) as AddressProviderValue
  const { customers, isLoading } = useCustomerList()

  useEffect(() => {
    if (!customers.length) {
      setSelectedAssociationId(null)
      return
    }

    const isCurrentInList = customers.some(
      (item) => item.association.id === selectedAssociationId
    )

    if (!isCurrentInList) {
      setSelectedAssociationId(customers[0].association.id)
    }
  }, [customers, selectedAssociationId, setSelectedAssociationId])

  if (isLoading) {
    return (
      <Box sx={{ px: 2, py: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Loading…
        </Typography>
      </Box>
    )
  }

  if (customers.length === 0) {
    return (
      <Box sx={{ px: 2, py: 2 }}>
        <Typography variant="body2" color="text.secondary">
          No customers found.
        </Typography>
      </Box>
    )
  }

  return (
    <Stack spacing={0}>
      {customers.map((item) => (
        <AddressCustomerListItem
          key={item.association.id}
          item={item}
          isSelected={item.association.id === selectedAssociationId}
          onSelect={() => setSelectedAssociationId(item.association.id)}
        />
      ))}
    </Stack>
  )
}

export default AddressCustomerList
